<div class="datepicker-wrapper">
  <div class="trigger-container">
    <button mat-button [matMenuTriggerFor]="dateFilterMenu" [disabled]="disabled">
      <div class="trigger-main-menu-button-content">
        <mat-icon class="material-icons-outlined text-normal">calendar_month</mat-icon>
        <div class="text-normal">
          <span *ngIf="selectedType === 'allTime'; else selectedRangeTemp">
            All Time
          </span>
          <ng-template #selectedRangeTemp>
            <span>
              {{filterDropDownLabel}}
            </span>
          </ng-template>
        </div>
        <mat-icon class="material-icons text-normal">arrow_drop_down</mat-icon>
      </div>
    </button>
    <mat-menu #dateFilterMenu="matMenu" xPosition="before">
      <ng-container *ngFor="let option of dateRangeOptions">
        <button 
          mat-menu-item 
          class="date-filter-option" 
          [class.bg-grey]="selectedType === option.value" 
          (click)="onFilterSelected(option.value)"
        >
          <span [class.primary-text]="selectedType === option.value">{{ option.label }}</span>
        </button>
      </ng-container>
      
      <button 
        mat-menu-item 
        class="date-filter-option" 
        [class.bg-grey]="selectedType === null" 
        (click)="openDatePicker()"
      ><span [class.primary-text]="selectedType === null">Custom</span></button>
    </mat-menu>

    <button class="trigger-datepicker" [matMenuTriggerFor]="datePickerMenu" #datePickerTriggerButton="matMenuTrigger" [disabled]="disabled"></button>
    <mat-menu 
      #datePickerMenu="matMenu" 
      xPosition="before" 
      class="datepicker-filter-panel"
    >
      <div class="px-16 py-8" (click)="$event.stopPropagation()" 
           (mousedown)="$event.stopPropagation()"
           (keydown)="$event.stopPropagation()">
        <div class="mat-body-2 mb-4">Select Date Range</div>
        <mat-divider class="mb-16"></mat-divider>
  
        <div class="inputs-row" [formGroup]="calendarRangeForm">
          <mat-form-field 
            appearance="outline" 
            class="inline-form-input" 
            [class.active-border]="activeField() === 'start'" 
            color="accent"
          >
            <mat-label>From</mat-label>
            <input 
              #startInput
              type="text"
              matInput
              formControlName="start"
              (focus)="onInputFocus('start')"
              (keydown)="restrictInput()" 
              placeholder="mm/dd/yyyy"
              [matDatepicker]="startPickerRef"
              [disabled]="disabled" 
            >
            <mat-datepicker color="accent" #startPickerRef></mat-datepicker>
          </mat-form-field>
  
          <span class="separator text-hint">-</span>
  
          <mat-form-field 
            appearance="outline" 
            class="inline-form-input" 
            [class.active-border]="activeField() === 'end'"
            color="accent"
          >
            <mat-label>To</mat-label>
            <input 
              #endInput
              type="text"
              matInput 
              formControlName="end"
              (focus)="onInputFocus('end')" 
              (keydown)="restrictInput()" 
              placeholder="mm/dd/yyyy"
              [matDatepicker]="endPickerRef"
              [disabled]="disabled"
            >
            <mat-datepicker color="accent" #endPickerRef></mat-datepicker>
          </mat-form-field>
  
        </div>
  
        <div class="calendar-container">
          <mat-calendar 
            [selected]="currentSelectedDate"
            [startAt]="startAtDate"
            [minDate]="minDate"
            [maxDate]="currentDate" 
            class="custom-calendar" 
            (selectedChange)="onDateSelected($event)">
          </mat-calendar>
        </div>
  
        <div class="picker-actions">
          <button mat-button color="accent" (click)="cancel()">Cancel</button>
          <button mat-button color="accent" (click)="apply()">OK</button>
        </div>
      </div>
    </mat-menu>

  </div>
</div>